import React,{useState} from "react";
import SideBar from "../../../../components/SideBar";
import Navbar from "../../../../components/Navbar";
import ReactDatePicker from "react-datepicker";
import moment from "moment";

const MaternityLeave = () => {
  let today = moment().format("DD-MMM-YYYY");
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    Purpose: "",
    FromDate: today,
    ToDate: today,
  });



  return (
    <>
      <div className="nest-page">
        <SideBar />
        <div className="Nav">
          <Navbar
            heading="Maternity Leave"
            heading_icon={<i className="fa fa-house-leave"></i>}
          />
        </div>
        <div className="container-fluid" id="skill_section">
        <div className="row">
        <div className="col-md-7">
              <div className="container-fluid" id="skill-table-area">
                <form>
                  <div className="row">
                    <div className="col-md-6">
                      <label for="leave-type" class="form-label">
                        Leave Type<span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="leaveType"
                        aria-describedby="leaveType"
                        name="leaveType"
                      />
                    </div>
                    <div className="mt-2">
                      <label for="leave-type" class="form-label">
                        Purpose<span className="required">*</span>
                      </label>
                      <textarea
                        type="text"
                        className={`form-control${
                          errors.Purpose ? "is-invalid" : ""
                        }`}
                        id="Purpose"
                        aria-describedby="Purpose"
                        name="Purpose"
                        // value={formData.Purpose}
                        // onChange={handleInputChange}
                      />
                      {errors.Purpose && (
                        <div className="invalid-feedback">{errors.Purpose}</div>
                      )}
                    </div>
                    <div className="col-sm-12 col-md-5 mt-2">
                      <label htmlFor="TargetDate" className="form-label">
                        From Date<span className="required">*</span>
                      </label>

                      <ReactDatePicker
                        autoComplete="off"
                        changeYear
                        changeMonth
                        showPopperArrow
                        showIcon
                        icon="fa fa-calendar"
                        className="form-control"
                        format="d-MM-YYYY"
                        name="FromDate"
                        id="FromDate"
                        dateFormat="dd-MMM-yyyy"
                      />
                    </div>
                    <div className="col-sm-12 col-md-5 mt-2">
                      <label htmlFor="TargetDate" className="form-label">
                        To Date<span className="required">*</span>
                      </label>

                      <ReactDatePicker
                        autoComplete="off"
                        minDate={new Date()}
                        changeYear
                        changeMonth
                        showPopperArrow
                        showIcon
                        icon="fa fa-calendar"
                        className="form-control"
                        format="d-MM-YYYY"
                        name="ToDate"
                        id="ToDate"
                        dateFormat="dd-MMM-yyyy"
                      />
                    </div>
                    <div className="col-sm-12 col-md-2 mt-2">
                      <div class="mb-3">
                        <label for="days" class="form-label">
                          No. of Days<span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control text-end"
                          id="days"
                          aria-describedby="days"
                          name="days"
                          disabled
                        />
                      </div>
                    </div>
                  </div>

                  <div className="text-end mt-2">
                    <button className="custom-btn me-2">Cancel</button>
                    <button type="submit" className="custom-btn">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
        </div>
        </div>
      </div>
    </>
  );
};

export default MaternityLeave;
